import { defineComponent as _defineComponent } from 'vue'
import InvoiceSection from '@/views/my-projects/components/invoice/InvoiceSection.vue';
import InvoiceAddressDataDisplay from '@/views/my-projects/components/invoice/addressdata/InvoiceAddressDataDisplay.vue';
import InvoiceAddressDataEditor from '@/views/my-projects/components/invoice/addressdata/InvoiceAddressDataEditor.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceAddressData',
  setup(__props) {

const addressDataSender = ref({
  name: 'Luschen Solutions GmbH',
  salutation: 'Frau',
  firstName: 'Nina',
  lastName: 'Cording',
  street: 'Dingensstraße',
  city: 'Hamburg',
  nr: '25a'
});

const addressDataRecipient = ref({
  name: 'Other Company',
  salutation: 'Herr',
  firstName: 'Karl-Heinz',
  lastName: 'Cording',
  street: 'Dingensstraße',
  city: 'Bremen',
  nr: '2',
  addition: 'Abt. 123'
});

const saveCallback = () => {
  console.log('Would save!');
};


return { __sfc: true,addressDataSender, addressDataRecipient, saveCallback, InvoiceSection, InvoiceAddressDataDisplay, InvoiceAddressDataEditor }
}

})